import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbTimepickerModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-shift-master-policy',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbTimepickerModule, NgbTooltip, LoaderComponent],
  templateUrl: './shift-master-policy.component.html',
  styleUrl: './shift-master-policy.component.scss'
})
export class ShiftMasterPolicyComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ShiftRuleDetailInput!: any;
  ShiftRuleDetail = {
    AttendanceType: null as any,
    Duration: null as any,
    DurationObj: null as any,
    HalfDayDuration: null as any,
    HalfDayDurationObj: null as any,
    IsGraceApplicable: false,
    FirstCheckInLateApplicable: false,
    FirstCheckInLate: null as any,
    FirstCheckInLateObj: null as any,
    LastCheckOutEarlyApplicable: false,
    LastCheckOutEarly: null as any,
    LastCheckOutEarlyObj: null as any,
    ShiftMargin: false,
    HourBeforeShiftStartApplicable: false,
    HourBeforeShiftStart: null as any,
    HourBeforeShiftStartObj: null as any,
    HourAfterShiftStartApplicable: false,
    HourAfterShiftStart: null as any,
    HourAfterShiftStartObj: null as any,
    HourAfterShiftEndApplicable: false,
    HourAfterShiftEnd: null as any,
    HourAfterShiftEndObj: null as any,
    IsSinglePunchAllowed: false,
  }

  constructor(
    protected tooltip: TooltipService,
    protected common: CommonService
  ) {}

  ngOnInit(): void {
    this.ShiftRuleDetail = this.ShiftRuleDetailInput;
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.ShiftRuleDetail.DurationObj != null) {
        this.ShiftRuleDetail.Duration = this.ShiftRuleDetail.DurationObj.hour + ':' + this.ShiftRuleDetail.DurationObj.minute;
      } else {
        this.ShiftRuleDetail.Duration = null;
      }

      if (this.ShiftRuleDetail.HalfDayDurationObj != null) {
        this.ShiftRuleDetail.HalfDayDuration = this.ShiftRuleDetail.HalfDayDurationObj.hour + ':' + this.ShiftRuleDetail.HalfDayDurationObj.minute;
      } else {
        this.ShiftRuleDetail.HalfDayDuration = null;
      }

      if (this.common.ToLowerCase(this.ShiftRuleDetail.AttendanceType) == 'time' && this.ShiftRuleDetail.IsGraceApplicable && this.ShiftRuleDetail.FirstCheckInLateApplicable && this.ShiftRuleDetail.FirstCheckInLateObj != null) {
        this.ShiftRuleDetail.FirstCheckInLate = this.ShiftRuleDetail.FirstCheckInLateObj.hour + ':' + this.ShiftRuleDetail.FirstCheckInLateObj.minute;
      } else {
        this.ShiftRuleDetail.FirstCheckInLate = null;
      }

      if (this.common.ToLowerCase(this.ShiftRuleDetail.AttendanceType) == 'time' && this.ShiftRuleDetail.IsGraceApplicable && this.ShiftRuleDetail.LastCheckOutEarlyApplicable && this.ShiftRuleDetail.LastCheckOutEarlyObj != null) {
        this.ShiftRuleDetail.LastCheckOutEarly = this.ShiftRuleDetail.LastCheckOutEarlyObj.hour + ':' + this.ShiftRuleDetail.LastCheckOutEarlyObj.minute;
      } else {
        this.ShiftRuleDetail.LastCheckOutEarly = null;
      }

      if (this.ShiftRuleDetail.ShiftMargin && this.ShiftRuleDetail.HourBeforeShiftStartApplicable && this.ShiftRuleDetail.HourBeforeShiftStartObj != null) {
        this.ShiftRuleDetail.HourBeforeShiftStart = this.ShiftRuleDetail.HourBeforeShiftStartObj.hour + ':' + this.ShiftRuleDetail.HourBeforeShiftStartObj.minute;
      } else {
        this.ShiftRuleDetail.HourBeforeShiftStart = null;
      }
      
      if (this.ShiftRuleDetail.ShiftMargin && this.ShiftRuleDetail.HourAfterShiftStartApplicable && this.ShiftRuleDetail.HourAfterShiftStartObj != null) {
        this.ShiftRuleDetail.HourAfterShiftStart = this.ShiftRuleDetail.HourAfterShiftStartObj.hour + ':' + this.ShiftRuleDetail.HourAfterShiftStartObj.minute;
      } else {
        this.ShiftRuleDetail.HourAfterShiftStart = null;
      }

      if (this.ShiftRuleDetail.ShiftMargin && this.ShiftRuleDetail.HourAfterShiftEndApplicable && this.ShiftRuleDetail.HourAfterShiftEndObj != null) {
        this.ShiftRuleDetail.HourAfterShiftEnd = this.ShiftRuleDetail.HourAfterShiftEndObj.hour + ':' + this.ShiftRuleDetail.HourAfterShiftEndObj.minute;
      } else {
        this.ShiftRuleDetail.HourAfterShiftEnd = null;
      }
      this.activeModal.close(this.ShiftRuleDetail);
    }
    else {
      form.submitted = true;
    }
  }

  timeFormate(event: any, type: String) {
    if (type == 'Duration') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.ShiftRuleDetail.DurationObj.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.ShiftRuleDetail.DurationObj.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    } else if (type == 'HalfDayDuration') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.ShiftRuleDetail.HalfDayDurationObj.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.ShiftRuleDetail.HalfDayDurationObj.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    }
  }

  AttendanceTypeChange() {
    if (this.ShiftRuleDetail.AttendanceType == 'hour') {
      this.ShiftRuleDetail.ShiftMargin = false;
    }
  }

  close() {
    this.activeModal.close();
  }
}
